import React from 'react';
import PropTypes from 'prop-types';
import { Thumbnail } from './Thumbnail.js';
import './StudyBrowser.styl';

function StudyBrowser(props) {
  const {
    studies,
    onThumbnailClick,
    onThumbnailDoubleClick,
    supportsDrag,
    showThumbnailProgressBar,
  } = props;

  const thumbnails = studies.reduce(
    (acc, cur) => [
      ...acc,
      ...cur.thumbnails.map(t => ({
        ...t,
        StudyInstanceUID: cur.StudyInstanceUID,
      })),
    ],
    []
  );
  thumbnails.sort((a, b) => {
    const aSeriesDate =
      a.SeriesDate || a.ContentDate || a.AcquisitionDate || '99999999';
    const bSeriesDate =
      b.SeriesDate || b.ContentDate || b.AcquisitionDate || '99999999';
    return Number(aSeriesDate) - Number(bSeriesDate);
  });

  return (
    <div className="study-browser">
      <div className="scrollable-study-thumbnails">
        {thumbnails.map((thumb, thumbIndex) => {
          const {
            active,
            altImageText,
            displaySetInstanceUID,
            imageId,
            numImageFrames,
            StudyInstanceUID,
            SeriesDescription,
            SeriesNumber,
            SeriesDate,
            ContentDate,
            AcquisitionDate,
          } = thumb;

          return (
            <div
              key={thumb.displaySetInstanceUID}
              className="thumbnail-container"
              data-cy="thumbnail-list"
            >
              <Thumbnail
                active={active}
                supportsDrag={supportsDrag}
                key={`${thumbIndex}`}
                id={`${thumbIndex}`}
                /** study */
                StudyInstanceUID={StudyInstanceUID}
                /** thumb */
                altImageText={altImageText}
                imageId={imageId}
                displaySetInstanceUID={displaySetInstanceUID}
                numImageFrames={numImageFrames}
                SeriesDescription={SeriesDescription}
                SeriesNumber={SeriesNumber}
                /** define series date */
                SeriesDate={SeriesDate || ContentDate || AcquisitionDate || ''}
                /** events */
                onClick={() => onThumbnailClick(displaySetInstanceUID)}
                onDoubleClick={onThumbnailDoubleClick}
                showProgressBar={showThumbnailProgressBar}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

const noop = () => {};

StudyBrowser.propTypes = {
  studies: PropTypes.arrayOf(
    PropTypes.shape({
      StudyInstanceUID: PropTypes.string.isRequired,
      thumbnails: PropTypes.arrayOf(
        PropTypes.shape({
          altImageText: PropTypes.string,
          displaySetInstanceUID: PropTypes.string.isRequired,
          imageId: PropTypes.string,
          numImageFrames: PropTypes.number,
          SeriesDescription: PropTypes.string,
          SeriesNumber: PropTypes.number,
          stackPercentComplete: PropTypes.number,
        })
      ),
    })
  ).isRequired,
  supportsDrag: PropTypes.bool,
  onThumbnailClick: PropTypes.func,
  onThumbnailDoubleClick: PropTypes.func,
  showThumbnailProgressBar: PropTypes.bool,
};

StudyBrowser.defaultProps = {
  studies: [],
  supportsDrag: true,
  onThumbnailClick: noop,
  onThumbnailDoubleClick: noop,
  showThumbnailProgressBar: true,
};

export { StudyBrowser };
